module.exports = __webpack_public_path__ + "04_mustache_grey.477f6801.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer3/04_mustache_grey.png
// module id = 5EPe
// module chunks = 0